// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6373d6bb","75":"c41c5197","101":"209e72c7","200":"c45a33c0","397":"3589a632","453":"cb4dfca2"}[chunkId] + ".chunk.js";
};